import type { ReactNode } from 'react';

import { cn } from '../lib/cn';

interface IClaimProps {
  children: ReactNode;
  size?: 'page' | 'card';
  footnote?: ReactNode;
  basis?: ReactNode;
  basisLabel?: string;
  className?: string;
}

export const Claim = ({
  children,
  size = 'page',
  footnote,
  basis,
  basisLabel = 'What that rests on',
  className,
}: IClaimProps) => (
  <div className={cn('rounded-panel bg-surface-sunken px-claim-x py-4', className)}>
    <p
      className={cn(
        'text-primary',
        size === 'page' ? 'text-section leading-23' : 'text-data leading-20',
      )}
    >
      {children}
    </p>
    {basis && (
      <>
        <p className="mt-3 mb-label font-mono text-micro text-faint">{basisLabel}</p>
        <div className="flex flex-col gap-1">{basis}</div>
      </>
    )}
    {footnote && <p className="mt-2 font-mono text-micro text-faint">{footnote}</p>}
  </div>
);
